<template>
    <v-card class="mx-auto mt-12" :width="wtam">
        <div class="primary pa-6 d-flex justify-center">
            <div>
                <v-img 
                    class=""
                    :src="require('@/assets/logo.png')"
                    width="140px"></v-img>
            </div>
        </div>

        <v-card-text v-if="user.role.pending === true">
            <div class="text-center">
                <div class="subtitle-1 mt-3" style="line-height:1.2">
                    <div>
                        Hi <span class="font-weight-bold grey--text text--darken-3">{{user.name}}</span>, thank you for signing with us.
                    </div>
                    <div class="mt-3">
                        We are checking your account. In short we´ll be confirming your access.
                    </div>
                </div>
                <v-btn depressed class="accent mt-8 mb-4" @click="signout">
                    Signout
                </v-btn>
            </div>
        </v-card-text>

        <v-card-text v-if="user.role.pending === false && user.group == undefined && loaded">
            <div class="text-center">
                <div class="subtitle-1 mt-3" style="line-height:1.2">
                    <div>
                        Hi <span class="font-weight-bold grey--text text--darken-3">{{user.name}}</span>, your access has been accepted.
                    </div>
                </div>

                <div class="mt-4 px-6">
                    <v-select
                        v-model="model.group"
                        :items="groups"
                        item-text="str"
                        item-value="id"
                        @change="getTeams"
                        append-icon="fa-angle-down primary--text"
                        label="Select a group">
                    </v-select>

                    <v-select
                        v-if="loadedTeams"
                        class="mt-4"
                        v-model="model.team"
                        :items="teams"
                        item-text="name"
                        item-value="id"
                        no-data-text="No teams created for this group"
                        append-icon="fa-angle-down primary--text"
                        label="Select a team">
                    </v-select>
                </div>

                <div class="d-flex justify-center">
                    <v-btn depressed class="info mt-8 mb-4 mr-6" @click="signout">
                        Signout
                    </v-btn>
                    <v-btn depressed class="accent mt-8 mb-4" @click="validate">
                        Save
                    </v-btn>
                </div>
            </div>
        </v-card-text>

        <SendingLoader v-if="!loaded" />
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'
import Groups from '@/firebase/groups'
import Teams from '@/firebase/teams'
import Users from '@/firebase/users'

export default {
    data: () => ({
        loaded: false,
        loadedTeams: false,
        model: {
            group: '',
            team: ''
        },
        groups: [],
        teams: []
    }),
    computed: {
        wtam() {
            if (this.$vuetify.breakpoint.xsOnly)    return '300px';
            if (this.$vuetify.breakpoint.smAndUp)    return '450px';
        }
    },
    mounted() {
        if (this.user.role.pending === false) {
            this.getGroups();
        } else {
            this.loaded = true;
        }
    },
    methods: {
        signout() {
            this.$store.dispatch('setUser', null);
        },
        getGroups() {
            Groups.getByCenter(this.user.center)
                    .then(response => {
                        if (response.status === true) {
                            this.groups = Helpers.formatItems(response.query);
                            this.formatSchedules();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        formatSchedules(gr) {
            this.groups.forEach(dt => {
                dt.str = dt.day + ' / ' + dt.hour;
            });
        },
        getTeams() {
            this.loadedTeams = false;

            Teams.getByGroup(this.user.center, this.model.group)
                    .then(response => {
                        if (response.status === true) {
                            this.teams = Helpers.formatItems(response.query);
                            this.loadedTeams = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        validate() {
            if (this.validateIsEmpty(this.model.group)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a group.'});
                return;
            }
            if (this.validateIsEmpty(this.model.team)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a team.'});
                return;
            }
            this.save();
        },
        save() {
            Users.setGroupAndTeam(this.user.uid, this.model)
                    .then(response => {
                        if (response === true) {
                            location.reload();
                            this.$store.dispatch('setSnack', {kind:'success', text:'Team and group is set.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>